import ProjectSession from "../../project-session"
import ProjectSingleViewProperties from "./productivity-proto"

export default class ProjectSingleViewFilesProperties extends ProjectSingleViewProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canCreateAttachments = true
    }
}
